import { Chuckle, Drip, Shiver } from "./Characters";

const WORDS = ["Two minutes", "Three feelings", "Free to enter", "AI and non-AI welcome", "Laughter", "Tears", "Fears"];
const ICONS = [Chuckle, Drip, Shiver];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {WORDS.map((w, i) => {
      const C = ICONS[i % 3];
      return (
        <span key={w} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-head text-4xl text-ink sm:text-6xl">{w}</span>
          <C className="h-10 w-10 sm:h-14 sm:w-14" />
        </span>
      );
    })}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y-2 border-ink bg-paper py-6 sm:py-8">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
